/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterDeliveryOptions_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterDeliveryOptions_itemSearch">;
    readonly " $refType": "SbRespRefineMenuFilterDeliveryOptions_itemSearch";
};
export type SbRespRefineMenuFilterDeliveryOptions_itemSearch$data = SbRespRefineMenuFilterDeliveryOptions_itemSearch;
export type SbRespRefineMenuFilterDeliveryOptions_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenuFilterDeliveryOptions_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterDeliveryOptions_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuFilterDeliveryOptions_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterDeliveryOptions_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '8b6bce311e661d4c02077b889d5a2642';
export default node;
